var eventTracker = {
  trackLanguageChange: function (newLanguage) {
    window.gtag('event', 'change', {
      'event_category': 'Language',
      'event_label': newLanguage
    })
  },
  trackSuccessfullSignIn: function () {
    window.gtag('event', 'signIn', {
      'event_category': 'Users',
      'event_label': 'today'
    })
  },
  trackVotingEvent: function (pollKey) {
    window.gtag('event', 'vote', {
      'event_category': 'Polls',
      'event_label': pollKey
    })
  },
  trackAppDownloadLink: function () {
    window.gtag('event', 'install', {
      'event_category': 'App'
    })
  },
  trackThemeChange: function (newTheme) {
    window.gtag('event', 'theme_change', {
      'event_category': 'Theme',
      'event_label': newTheme
    })
  }
}

export default eventTracker



// WEBPACK FOOTER //
// ./src/services/eventTracker.js